<template>
  <div>
    <div class="percentage-schell" :style="percentStyle(value)">{{ value }}%</div>
  </div>
</template>

<script>
import { percentStyle } from '../../libraries/spcore';
export default {
  props: ['value'],
  methods: {
    percentStyle,
  },
}
</script>

<style lang="scss" scoped>
.percentage-schell {
  display: inline-block;
  border-radius: 100px;
  margin-top: auto;
  margin-bottom: auto;
  padding: 9px 12px;
}
</style>